<script setup lang="ts">
import * as R from 'remeda'
import type { RangeValue } from '../../../types/api/reports'

defineProps<{ value: RangeValue; decimals: number; scale: number; unit?: string }>()
</script>

<template>
  <div>
    {{ value && value.map(val => R.round(Number(val) * scale, decimals)).join(' - ') }}
    {{ unit }}
  </div>
</template>
